import React, { Component } from "react";
import "./Welcome.scss";

export default class Welcome extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="padding">
                    <div className="container">
                        <div className="logo"></div>
                        <div className="subtitle"></div>
                        <div className="desc"></div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx